<template>
  <div class="app-main-content">
    <div
      v-show="showMainList"
      class="main-content"
      type="primary"
    >
      <fcl-addon-search-bar
        :filter="filter"
        @advSearchItemResetCallBack="toAdvancedQuery"
      >
        <template slot="operations">
          <el-button no="onEdit" type="primary" :disabled="!this.selectRow" @click="onEdit()">{{ $t('Pricing.Edit') }}</el-button>
          <el-button no="onDelete" type="danger" @click="onDelete()">{{ $t('Pricing.Delete') }}</el-button>
          <el-button no="onAdd" type="primary" @click="onAdd()">{{ $t('Pricing.Add') }}</el-button>
          <el-button no="onDownloadTemplate" type="primary" @click="onDownloadTemplate()">{{ $t('Pricing.Template') }}</el-button>
          <el-upload
            no="uploadExcelSuccess"
            :action="URL.price.shippingSchedule.saveShippingScheduleExcelFile"
            :headers="{sessionId}"
            :show-file-list="false"
            accept=".xls, .xlsx"
            :on-success="uploadExcelSuccess"
            :data="{currentOfficeId:$store.getters.currentOfficeId}"
            style="display: inline-block; margin-left: 5px"
          >
            <el-button no="import" type="primary">{{ $t('Pricing.Import') }}</el-button>
          </el-upload>
        </template>
      </fcl-addon-search-bar>
    </div>
    <shipping-schedule-data-grid
      config-module="220501"
      :row-data="rowData"
      :show-approve="false"
      :filter="filter"
      :grid-options="gridOptions"
      @selectRowChange="selectRowChange"
    />
    <shipping-schedule-form
      :visible="shippingScheduleFormDialog.visible"
      :ss="shippingScheduleFormDialog.ss"
      :is-new="shippingScheduleFormDialog.isNew"
      @close="onShippingScheduleFormDialogClose"
      @reload="toQuery"
    />
  </div>
</template>

<script>

import { getLoading } from '@/utils/utilBaseElement'
import { queryShippingSchedule, deleteShippingSchedule } from '@/api/price/shippingSchedule'
import DateUtils from '@/utils/dateUtils'
import { MultiCompanyUtil } from '@/class/cargo/model/utils/MultiCompanyUtil'
import { PricingFCLConfigUtil } from '@/class/cargo/model/utils/PricingFCLConfigUtil'
import StrUtils from '@/utils/StrUtils'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import URL from '@/api/urlTranslator'
import { PriceUploadExceptionUtil } from '@/class/cargo/model/utils/PriceUploadExceptionUtil'
import SurchargeFclDataGrid from '@/views/cargo/v0/Price/SurchargeFCL/components/surchargeFclDataGrid'
import * as PriceConstant from '@/class/cargo/model/parameters/PriceConstant'
import LocalStorageUtils from '@/utils/localStorageUtils'
import FclAddonSearchBar from '@/views/cargo/v0/Price/components/query/fclAddonSearchBar'
import ShippingScheduleDataGrid from '@/views/cargo/v0/Price/components/grid/shippingScheduleDataGrid'
import ShippingScheduleForm from '@/views/cargo/v0/Price/ShippingSchedule/components/shippingScheduleForm'

export default {
  name: 'ShippingSchedule',
  components: {
    ShippingScheduleForm,
    ShippingScheduleDataGrid,
    FclAddonSearchBar,
    SurchargeFclDataGrid },
  data() {
    return {
      URL,
      isHQManager: false,
      remarkChange: '',
      targetLevel: 99,
      txtRemarks: '',
      showLevel: false,
      showDetail: false,
      fullscreenLoading: null,
      proxy: {},
      filter: {
        pol: '',
        pod: '',
        carrier: '',
        createdBy: 0,
        branch: 0,
        beginDate: DateUtils.formatStandardDate(new Date()),
        endDate: ''
      },
      rowData: [],
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowDoubleClicked: this.onRowDoubleClicked
      },
      shippingScheduleFormDialog: {
        visible: false,
        ss: {
          days: 0
        },
        isNew: false
      },
      selectRow: null, // 已发布的单击选择行
      deleteAllowed: false,
      inputAllowed: false,
      priceFclUtil: null
    }
  },
  computed: {
    showMainList() {
      return !this.showDetail
    },
    sessionId() {
      return this.$store.getters.token
    }
  },
  watch: {
    '$store.getters.currentOfficeId': function() {
      this.init()
    },
    activeTabName(val) {
      LocalStorageUtils.setConfiguration('SurchargeFCL', val)
    }
  },
  beforeMount() {
    this.init()
  },
  methods: {
    async init() {
      this.isHQManager = MultiCompanyUtil.getInstance().isHQManager('PriceFcl')
      this.priceFclUtil = await PricingFCLConfigUtil.getInstance()
      if (this.$store.getters.isAdmin) {
        this.deleteAllowed = true
        this.inputAllowed = true
      } else {
        this.inputAllowed = this.priceFclUtil.isInput
      }
    },
    toAdvancedQuery(data) {
      this.proxy = data
      this.toQuery()
    },
    onShippingScheduleFormDialogClose() {
      this.shippingScheduleFormDialog.visible = false
      this.shippingScheduleFormDialog.data = {}
    },
    toQuery() {
      this.fullscreenLoading = getLoading()
      queryShippingSchedule(this.proxy).then((res) => {
        this.loadingEnd()
        this.rowData = res.data
        if (this.rowData && this.rowData.length === 0) {
          this.$message.warning(this.$t('Pricing.NoRecord'))
          return
        }
        if (this.rowData.length > PriceConstant.MAX_QUERY_COUNT) {
          this.rowData.pop() // 删除第PriceConstant.MAX_QUERY_COUNT+1条
          this.$message.warning(this.$t('Pricing.MaxQueryCount'))
        }
      }).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    loadingEnd() {
      this.gridOptions.api.clearFocusedCell()
      this.selectRow = null
      this.fullscreenLoading.close()
    },
    onRowDoubleClicked(e) {
      const data = e.data
      this.selectRow = data
      this.edit(data)
    },
    onEdit() {
      this.edit(this.selectRow)
    },
    onDelete() {
      const selectedRows = this.getSelectedRowsCp()
      if (selectedRows === null) {
        return
      }
      const message = selectedRows.length > 1 ? this.$t('Pricing.IsDeleteRecords') : this.$t('Pricing.IsDeleteRecord')
      this.$confirm(message, this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        const uuids = this.getSelectUuids(selectedRows)
        this.fullscreenLoading = getLoading()
        deleteShippingSchedule(uuids).then(res => {
          this.$message.success(this.$t('Message.DeleteSuccessfully'))
          this.gridOptions.api.updateRowData({ remove: selectedRows })
        }).finally(() => {
          this.loadingEnd()
        })
      })
    },
    // 获取已发布的勾选数据
    getSelectedRowsCp() {
      const { api } = this.gridOptions
      const selectedRows = api.getSelectedRows()
      if (selectedRows.length === 0) {
        this.$message.warning(this.$t('Pricing.NoRecordSelect'))
        return null
      }
      for (const item of selectedRows) {
        if (!this.deleteAllowed && item.createdBy !== this.$store.getters.userId) {
          this.$message.warning(this.$t('Pricing.NotAllowedDelete'))
          return null
        }
      }
      return selectedRows
    },
    edit(selectRow) {
      if (!this.inputAllowed) return
      if (!selectRow) {
        this.$message.warning(this.$t('Pricing.NoRecordSelect'))
        return
      }
      this.shippingScheduleFormDialog.visible = true
      this.shippingScheduleFormDialog.isNew = false
      this.shippingScheduleFormDialog.ss = selectRow
    },
    getSelectUuids(selectedRows) {
      const uuids = []
      selectedRows.forEach(item => {
        uuids.push(item.uuid)
      })
      return uuids
    },
    onAdd() {
      this.shippingScheduleFormDialog.visible = true
      this.shippingScheduleFormDialog.isNew = true
      this.shippingScheduleFormDialog.ss = {
        closingDay: '',
        departureDay: '',
        days: 0
      }
    },
    onDownloadTemplate() {
      ExportUtils.downloadTemplateFile('Shipping_Schedule_sample.xls', 'price')
    },
    selectRowChange(data) {
      this.selectRow = data
    },
    uploadExcelSuccess(response, file, fileList) {
      if (response && response.data) {
        this.onImportSucceeded(JSON.parse(response.data))
      } else {
        this.$message.error(this.$t('SeaExport.ImportFailedContactAdministrator'))
      }
    },
    onImportSucceeded(message) {
      if (message.success) {
        const result = message.resultMessage
        if (result === '') {
          this.$message.error(this.$t('Pricing.NoRecordUpload'))
          return
        }
        const records = result.split(',')
        let msg = ''
        if (records.length > 1) {
          for (const sheet of records) {
            if (StrUtils.isEmpty(sheet)) {
              continue
            }
            const tmp = sheet.split(':')
            msg += StrUtils.substitute(this.$t('Pricing.Records'), tmp) + '\n'
          }
          msg += this.$t('Pricing.LoadSucceed')
          this.$message.success(msg)
        } else {
          const tmp = result.split(':')
          msg = StrUtils.substitute(this.$t('Pricing.Records'), tmp)
          msg = msg.substr(0, msg.length - 1) + this.$t('Pricing.LoadSucceed')
          this.$message.success(msg)
        }
        return false
      }
      // 导入失败
      const failResult = PriceUploadExceptionUtil.handleError(message)
      const msg = {
        dangerouslyUseHTMLString: true,
        message: failResult.replace(/\n\t/g, '<br/>'),
        type: 'error',
        duration: 5000
      }
      this.$message.error(msg)
    }
  }
}
</script>

<style scoped>

</style>
